<div class="stats-block" [ngClass]="mode + '-mode'" (click)="selectBlock(kpi)" [class.selected]="selected">
	<div *ngIf="!loading" class="num-and-link">
		<div *ngIf="kpi.isPercentage" class="count">
			{{ kpi.finalSum | truncate: 1:2:3 }}%
		</div>
		<div *ngIf="kpi.isMonthly" class="count">
			{{ kpi.finalSum | truncate: 1:2:3 }}<span class="per-month"> / mo</span>
		</div>
		<div *ngIf="kpi.isTime" class="count">
			{{ kpi.finalSum | seconds: '' : true : true }}
		</div>
		<div *ngIf="kpi.isFloat" class="count">
			{{ kpi.finalSum | number:'1.0-2' || 0 }}
		</div>
		<div *ngIf="!kpi.isPercentage && !kpi.isMonthly && !kpi.isTime && !kpi.isFloat" class="count"
			[innerHtml]="kpi.finalSum | truncate: 1:2:4 | numberWithLetter">
		</div>

		<a *ngIf="mode !== 'sidebar' && project" [title]="'GOTO_KPI' | translate" [hasPublicationField]="'rootOnly'"
			class="redirect-arrow" [routerLink]="['/library/project/', project.id, 'analysis']"
			(click)="navigateToKpi(kpi, project.id)">
			<i class="fa fa-arrow-right-long"></i>
		</a>
	</div>

	<div class="num-and-link" *ngIf="loading">
		<div class="count">...</div>
	</div>

	<div class="title-line">
		<span class="kpi-label">
			{{ kpi.label }}
		</span>
		<bb-info class="description" *ngIf="kpi.description" [contents]="kpi.description" [icon]="'info'"
			[changeDetector]="changeDetector"></bb-info>
	</div>
	<div *ngIf="kpi && !kpi.isDefault && kpi.goal" class="goal-line">
		<span class="goal-calculated-percentage" [class.ds-orange]="kpi.delta < 100"
			[class.ds-green]="kpi.delta >= 100">{{ kpi.delta | truncate: 0.01:2:3 }}%</span>
		<span>&nbsp;{{ 'OF_YOUR_GOAL_OF' | translate }}&nbsp;</span>
		<span *ngIf="kpi.isPercentage" class="goal">{{ kpi.goal | truncate: 1:2:3 }}%</span>
		<span *ngIf="kpi.isMonthly" class="goal">{{ kpi.goal | truncate: 1:2:3 }}<span class="per-month"> /
				mo</span></span>
		<span *ngIf="kpi.isTime" class="goal">{{ kpi.goal | seconds }}</span>
		<span *ngIf="!kpi.isPercentage && !kpi.isMonthly && !kpi.isTime" class="goal">
			<span [innerHtml]="kpi.goal | truncate: 1:2:4 | numberWithLetter"></span>
		</span>
	</div>
</div>
